const mixinHighCharts = {
	methods: {
		graph(highChartsData) {
			let chartOptions = {		
				chart: {
					zoomType: 'xy',
				  },
				tooltip: {
					shared: true,
					useHTML: true
				},
				plotOptions: {
					areaspline: {
						fillOpacity: 0.4
					},
					arearange:{
						fillOpacity: 0.4
				 },
					column: {
						opacity: 1
					}
				},
				title: highChartsData.title,
				subtitle: highChartsData.subtitle,
				xAxis: [highChartsData.xAxis],
				yAxis: highChartsData.yAxis,
				series: highChartsData.series,
			};
			return chartOptions;
		}
	}
}
export default mixinHighCharts